'use client';

import React from 'react';
import IconArrow from '@/components/svgs/icons/arrow-icon';
import { cn } from '@/helpers/common';
import { TBreadcrumbs } from '@/ts/types';

const Breadcrumbs = ({
  breadcrumbs,
  breadcrumbsClassNames,
}: {
  breadcrumbs: TBreadcrumbs;
  breadcrumbsClassNames: {
    mainClassName: string;
    activeElementClassName: string;
    disabledElementClassName: string;
    arrowClassName: string;
  };
}) => {
  return (
    <div className={cn('w-full flex flex-wrap', breadcrumbsClassNames.mainClassName)}>
      {breadcrumbs.slice(0, -1).map((el) => (
        <div className={cn('flex justify-center items-center')} key={el.text}>
          <a
            className={cn('default-transition', breadcrumbsClassNames.activeElementClassName)}
            href={el.link ?? '/'}
          >
            {el.text}
          </a>
          <IconArrow
            className={cn(
              'w-3 h-1.75 shrink-0 -rotate-90',
              breadcrumbsClassNames.arrowClassName,
            )}
          />
        </div>
      ))}
      <div className={cn('', breadcrumbsClassNames.disabledElementClassName)}>
        {breadcrumbs.slice(-1)[0].text}
      </div>
    </div>
  );
};

export default Breadcrumbs;
